<template>
  <section class="container m-auto h-full container flex justify-center items-center">   
    <div class="w-5/6 sm:w-5/6 md:w-3/4 lg:w-3/4 xl:w-3/4" v-bind:class="[ error ? 'p-12 border-2 rounded-md border-red-800 bg-red-200' : '']">
      <p v-if="error" class="text-center text-2xl text-red-800 mb-6">{{error}}</p>
      <article>
        <header
          class="max-w-full text-xl leading-8 select-none p-4 mb-6">
          <span class="text-base text-blue-500 leading-7">{{question.prefix}}.</span>
          {{question.text}}
        </header>
        <div class="overflow-hidden h-auto gap-3 p-4">
          <div v-for="(item, index) in question.items" :key="index">
            <div class="grid grid-cols-6 sm:grid-cols-5 md:grid-cols-10 lg:grid-cols-10 xl:grid-cols-10 grid-flow-col max-w-full p-2 text-l leading-8 cursor-pointer bg-blue-200 mt-6 text-blue-800 border-2 border-blue-700 rounded-md" @click="toggleAccordion(index)">
              <div class="col-span-6 sm:col-span-4 md:col-span-9 lg:col-span-9 xl:col-span-9">
                <span class="text-base leading-7">{{item.prefix}}</span> 
              {{item.text}}
              </div>
              <div v-if="!isMobile()" class="col-span-1">
                <svg v-if="isOpen !== index" class="inline justify-self-end transition-colors duration-200 w-7 h-7" height="30" width="30" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
                <svg v-if="isOpen === index" class="inline justify-self-end transition-colors duration-200 w-7 h-7" height="32" width="32" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                </svg>
              </div>
            </div>
            <p v-if="item.secondaryText" class="text-gray-800">{{item.secondaryText}}</p>
              <div v-if="isOpen === index" class="mb-6 mt-2 bg-blue-100 border-2 border-blue-700 rounded-md" :class="{active: isOpen === index}">
                <div v-for="(option, index2) in question.answerOptions" :key="index2">
                  <div class="grid grid-flow-col grid-cols-5 sm:grid-cols-5 md:grid-cols-10 lg:grid-cols-10 xl:grid-cols-10 items-center">
                      <!-- check box -->
                      <radio-button class="col-start-1 span-1" v-bind:status="queryStatus(item.linkId, option.value.value)" @toggle="onToggle(item.linkId, option.value.value, index)"></radio-button>
                      <!-- answer text -->
                      <div class="col-start-2 sm:col-start-3 md:col-start-2 lg:col-start-2 xl:col-start-2 col-span-4 pl-2 sm:col-span-4 md:col-span-9 lg:col-span-9 xl:col-span-9items-center text-l text-gray-800">{{option.value.display}}</div> 
                  </div>
                </div>
              </div>
            <!-- display answer below answered accordian -->
              <div v-if="isOpen !== index && displayAnswer(item.linkId)" class="grid grid-cols-10 grid-flow-col max-w-full p-2 text-l leading-8 cursor-pointer bg-blue-100 mb-6 mt-2 text-blue-800 border-2 border-blue-700 rounded-md">
                <div class="col-span-1">
                  <svg class="inline justify-self-end text-blue-500 duration-200 w-7 h-7" height="24" width="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div class="col-span-9">
                  <span class="text-base text-blue-500 leading-7">{{ displayAnswer(item.linkId) }}</span> 
                </div>
              </div>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
import RadioButton from "@/components/RadioButton.vue";

export default {
  props: ['error', "index", "question"],
  data() {
    return {
      answer: {},
      isOpen: null,
    };
  },
  methods: {
    displayAnswer(childQuestionId) {
      if (this.answer[childQuestionId]) {
        return `Answer: ${this.answer[childQuestionId]}`
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      }
      return false;
    },
    onToggle (childQuestionId, answerValue, questionIndex) {
      // if the ticked answer is already stored, delete it to toggle
      if (this.answer[childQuestionId] && this.answer[childQuestionId] === answerValue) {
        this.$delete(this.answer, childQuestionId)
      } else {
        // if there's already a different answer stored for this question, delete it
        if (this.answer[childQuestionId]) this.$delete(this.answer, childQuestionId)
        this.$set(this.answer, childQuestionId, answerValue)
        // skip to next child question in section
        this.isOpen = questionIndex + 1
      }
      // skip to next child question in section
      this.isOpen = questionIndex + 1
      this.$emit("answered", this.question, this.answer);
    },
    // check if answer has been selected
    queryStatus(childQuestionId, value) {
      if (this.answer[childQuestionId])
        return this.answer[childQuestionId] === value;
      else return false;
      // return (typeof this.answer[childQuestionId] != "undefined" && this.answer[childQuestionId][value])
    },
    readQuestion(questionText) {
      const synth = window.speechSynthesis;
      const questionSpeech = new SpeechSynthesisUtterance(questionText);
      synth.speak(questionSpeech);
    },
    toggleAccordion(index) {
      if (this.isOpen === index) this.isOpen = null;
      else if (this.isOpen !== index) this.isOpen = index
      else this.isOpen;
    },
  },
  // load first question in each section on window load
  mounted:function(){
    this.isOpen = 0;
  },
  components: {
    RadioButton,
  },
};
</script>
